import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import messages from "../messages";
import errorManage from '../errorManage';
import centercostServices from './centercost.services';


toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const resetVaccines = () => async (dispatch, getState) => {
  dispatch({
    type: actions.FORM_FAIL,
    payload: "",
  });
}

export const getCenterCost = (type) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Centro_Costo/' : '/api/app/Funcional_Centro_Costo/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   // params: data
    // });
    const resp = await centercostServices.getCenterCost({}, type);
    dispatch({
      type: actions.GET_COST_CENTER,
      payload: {
        centerCost: resp.data.data,
        centerCostLength: resp.data.count
      }
    });
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: false
    });
  }
}

export const getCenterCostWithPagination = (params, type) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Centro_Costo/' : '/api/app/Funcional_Centro_Costo/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: params
    // });
    const resp = await centercostServices.getCenterCost(params, type);
    dispatch({
      type: actions.GET_COST_CENTER,
      payload: {
        centerCost: resp.data.data,
        centerCostLength: resp.data.count
      }
    });
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: false
    });
  }
}

export const saveCenterCost = (data, type, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COST_CENTER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Centro_Costo/' : '/api/app/Funcional_Centro_Costo/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await centercostServices.saveCenterCost(data, type);
    const { centerCost, centerCostLength } = getState().centerCost;
    const aCenterCost = [...centerCost, resp.data];
    dispatch({
      type: actions.GET_COST_CENTER,
      payload: {
        centerCost: aCenterCost,
        centerCostLength: centerCostLength + 1
      }
    });
    setShowModal(false)
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_COST_CENTER,
      payload: false
    });
  }
}

export const editCenterCost = (data, id, index, type, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COST_CENTER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Centro_Costo/${id}/` : `/api/app/Funcional_Centro_Costo/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await centercostServices.editCenterCost(id, data, type);
    const { centerCost, centerCostLength } = getState().centerCost;
    centerCost[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_COST_CENTER,
      payload: {
        centerCost: centerCost,
        centerCostLength: centerCostLength
      }
    });
    setShowModal(false);
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_COST_CENTER,
      payload: false
    });
  }
}

export const deleteCenterCost = (id, index, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Centro_Costo/${id}/` : `/api/app/Funcional_Centro_Costo/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await centercostServices.deleteCenterCost(id, type);
    const { centerCost, centerCostLength } = getState().centerCost;
    centerCost.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_COST_CENTER,
      payload: {
        centerCost: centerCost,
        centerCostLength: centerCostLength -1
      }
    });
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COST_CENTER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOAGIND_COST_CENTER,
      payload: false
    });
  }
}
